/**
 * Krok UI8 — čistá kopie `packages/contexts/identity/src/internal/ip-allowlist.ts`
 * (`ipMatchesRange`/`isIpAllowed`). Server zůstává jediný zdroj pravdy
 * (fail-closed kontrola při přihlášení); tahle kopie jen dovolí ve formuláři
 * ukázat varování „nezamkni se" okamžitě, bez kulaté cesty na server při
 * každém úderu do klávesy.
 */

function ipv4ToInt(ip: string): number | null {
  const parts = ip.split('.');
  if (parts.length !== 4) return null;
  let result = 0;
  for (const part of parts) {
    if (!/^\d{1,3}$/.test(part)) return null;
    const n = Number(part);
    if (n > 255) return null;
    result = (result << 8) + n;
  }
  return result >>> 0;
}

/** `ip` v `range` - presna shoda, nebo CIDR (napr. '203.0.113.0/24'). Neplatny/IPv6 vstup => false. */
export function ipMatchesRange(ip: string, range: string): boolean {
  const [rangeIp, prefixRaw] = range.trim().split('/');
  if (rangeIp === undefined) return false;
  const ipInt = ipv4ToInt(ip);
  const rangeInt = ipv4ToInt(rangeIp);
  if (ipInt === null || rangeInt === null) return false;
  if (prefixRaw === undefined) return ipInt === rangeInt;
  const prefix = Number(prefixRaw);
  if (!Number.isInteger(prefix) || prefix < 0 || prefix > 32) return false;
  const mask = prefix === 0 ? 0 : (0xffffffff << (32 - prefix)) >>> 0;
  return (ipInt & mask) === (rangeInt & mask);
}

/** Prazdny seznam = bez omezeni. */
export function isIpAllowed(ip: string, ranges: readonly string[]): boolean {
  if (ranges.length === 0) return true;
  return ranges.some((range) => ipMatchesRange(ip, range));
}

/** Stejny vzor jako `ipOrCidrSchema` v `apps/api/src/routes/tenant-settings.ts`. */
export const IP_OR_CIDR_PATTERN = /^(\d{1,3}\.){3}\d{1,3}(\/(\d|[12]\d|3[0-2]))?$/;
